import { useSelector } from "react-redux";
import MetricMonthTable from "./MetricMonthTable";
import { format } from "date-fns"; // Import date-fns for date formatting

const MetricMonthTableView = () => {
  const forecastGraphAndTableData = useSelector(
    (state: any) => state.forecasters?.forecastGraphAndTableData
  );

  // Transform the data
  const rows =
    forecastGraphAndTableData?.query_output?.map((item: any) => ({
      Period: item.Month ? format(new Date(item.Month), "MMM yyyy") : "N/A",
      Forecast:
        item.Target !== null
          ? parseFloat((parseFloat(item.Target)).toFixed(2))
          : "",
      Actual:
        item.Actual !== null
          ? parseFloat((parseFloat(item.Actual)).toFixed(2))
          : "",
      Deviation:
        item.Deviation !== null
          ? parseFloat(((item.Deviation)).toFixed(2))
          : "",
    })) || [];

  return (
    <>
      <MetricMonthTable rows={rows} />
    </>
  );
};

export default MetricMonthTableView;
